import { render, staticRenderFns } from "./MedicoLista.vue?vue&type=template&id=06413931&"
import script from "./MedicoLista.vue?vue&type=script&lang=js&"
export * from "./MedicoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports